
export default {
  props: {
    items: { type: Array, default: () => [] }
  },

  data() {
    return {
      combos: [],
      onHoldItems: []
    };
  },
  mounted() {
    this.combos = this.getCombos();

    // combine list of combos with normal items
    this.onHoldItems = [...this.getOnHoldItems(), ...this.combos];
  },
  methods: {
    /**
     * Get list of all distinct combos from items list
     */
    getCombos() {
      let combos = [];
      this.items.forEach(item => {
        const duplicate = combos.find(combo => combo.id === item.combo?.id);
        if (item.combo && !duplicate) {
          item.combo["items"] = [];
          item.combo["item_name"] = item.combo.name;
          item.combo["quantity"] = item.combo_quantity;
          combos.push(item.combo);
        }
      });
      return combos;
    },
    /**
     * Populate combos list with corresponding items and other items to different list
     */
    getOnHoldItems() {
      let onHoldItems = [];
      this.items.forEach(item => {
        if (item.combo) {
          const matchingCombo = this.combos.find(
            combo => combo.id === item.combo.id
          );

          // mark the whole combo as out of stock if one of the items is out of stock
          matchingCombo.items.push(item);
          const isOutOfStock = matchingCombo.items.find(
            item => !!item.out_of_stock
          );
          matchingCombo["out_of_stock"] = isOutOfStock;
        } else {
          onHoldItems.push(item);
        }
      });
      return onHoldItems;
    }
  }
};
